import {Form as FormR} from 'react-bootstrap';
import NavBar from "../NavBar/navbar";
import "./proposal.css"
import React, {useState} from 'react';
import { useLocation } from "react-router-dom";
import { useContext, useEffect, useRef } from 'react';
import { Input, Form, Table, Checkbox } from 'antd';
import SubNavBar from "../SubNavBar/subnavbar";
import { Row,Col, Container, Button } from 'react-bootstrap';
import Collapse from 'react-bootstrap/Collapse';
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import Modal from 'react-bootstrap/Modal';
import { useNavigate } from 'react-router-dom';
import { SearchOutlined } from '@ant-design/icons';

import { Tooltip } from 'antd';
import { getTokenUser, getTokenEmail } from '../../helper/token';
import AxiosHelper from '../../helper/axios-helper';

function Proposal() {
    const state = useLocation();

    const ACCOUNT_EMAIL = process.env.REACT_APP_ACCOUNTS_EMAIL;
    const [loggedInUser] = useState(getTokenUser());
    const [shouldLogIn,setShouldLogIn] = useState(false);
    const [proposalTableOpen] = useState(true);
    const [proposal, setProposal] = useState({});
    const [invoiceData, setInvoiceData] = useState([]);
    const [subNavValues,setSubNavValues] = useState([]);
    const [customerOptions, setCustomerOptions] = useState([]);
    const [frequencyTypeOptions, setFrequencyTypeOptions] = useState([]);
    const [vat,SetVat] = useState("");
    const [deleteInvHeaderModalShow, setDeleteInvHeaderModalShow] = useState(false);
    const [deleteInvoiceLineModalShow, setInvoiceLineDeleteModalShow] = useState(false);
    const [cancelModalShow, setCancelModalShow] = useState(false);
    const [cancelPropModalShow, setCancelPropModalShow] = useState(false);
    const [selectedDeleteInvoice, setSelectedDeleteInvoice] = useState("");
    const [selectedInvoiceLineDelete, setSelectedInvoiceLineDelete] = useState("");
    const [isCreateValidated, setIsCreateValidated] = useState(false);
    const [eventToChange] = useState();
    const [selectedSendInvoice, setSelectedSendInvoice] = useState("");
    const [sendInvHeaderModalShow, setSendInvHeaderModalShow] = useState(false);

    const [editNotesShow, setEditNotesShow] = useState(false);
    const [selectedNotes, setSelectedNotes] = useState("");
    const [newSelectedNotes, setNewSelectedNotes] = useState("");

    const [editLineNotesShow, setEditLineNotesShow] = useState(false);
    const [selectedLineNotes, setSelectedLineNotes] = useState("");
    const [newSelectedLineNotes, setNewSelectedLineNotes] = useState("");

    const [editDocumentLinkShow, setEditDocumentLinkShow] = useState(false)
    const[selectedDocumentLink, setSelectedDocumentLink] = useState("");
    const[newSelectedDocumentLink, setNewSelectedDocumentLink] = useState("");
    const [invoiceSentFilters] = useState([
      {
        text: 'Yes',
        value: 'Yes'
      },
      {
        text: 'No',
        value: 'No'
      },
    ]);
    const [invoicePaidFilters] = useState([
      {
        text: 'Yes',
        value: 'Yes'
      },
      {
        text: 'No',
        value: 'No'
      },
    ]);
    const [sentSelectedFilters, setSentSelectedFilters] = useState(['No']);
    const [paidSelectedFilters, setPaidSelectedFilters] = useState(['No']);
    const navigate = useNavigate();

    let proposalId = 0;

    try 
    {
        if (state.state !== null) 
        {
            proposalId = state.state.split('-')[0];
        }
    } 
    catch (error) 
    {
        alert(error);
    }

    //#endregion

    //#region Populate UI

    React.useEffect(()=>{

      populateUI();

    },[]);
    //#endregion

    //#region Table column definitions

    const InvoiceLineColumns=[{
        title:"Line Description",
        dataIndex:"invoice_line_description",
        render: (text, record, index) => {
          let isValid = true;
          
          if(record.invoice_line_description==="-"){
              isValid = false;
          }

          return(
            <div style={{minWidth: '150px', display: "flex", position:"relative"}}>
              {!isValid && 
                <Tooltip title="Invoice line description can't be '-'." color="#f88d8d">
                    <p className={"exclamation"}>!</p>
                </Tooltip>
              }  
              <FormR.Control 
                className={`editable-cell-input ${!isValid ? 'invalid-cell' : ''}`}
                size="sm" 
                type="text" 
                defaultValue={record.invoice_line_description} 
                onBlur={(e) => handleInvLineDescriptionChange(e, record)}
              ></FormR.Control>
            </div>  
          )
        }
    },
    {
        title:"Line Quantity",
        dataIndex:"invoice_line_quantity",
        render: (text, record, index) => {
          let isValid = true;
          
          if(parseFloat(record.invoice_line_quantity) <= 0){
              isValid = false;
          }

          return(
            <div style={{display: "flex", position:"relative"}}>
              {!isValid && 
                <Tooltip title="Invoice line quantity can't be negative or 0." color="#f88d8d">
                    <p className={"exclamation"}>!</p>
                </Tooltip>
              }  
              <FormR.Control 
                className={`editable-cell-input ${!isValid ? 'invalid-cell' : ''}`}
                size="sm" 
                type="number" 
                defaultValue={record.invoice_line_quantity} 
                onBlur={(e) => handleInvLineQuantityChange(e, record)}
              ></FormR.Control>
            </div>  
          )
        }
    },
    {
        title:"Line Unit Value",
        dataIndex:"invoice_line_unit_value",
        render: (text, record, index) => {
          let isValid = true;
          
          if(parseFloat(record.invoice_line_unit_value) <= 0){
              isValid = false;
          }

          return (
            <div style={{display: "flex", position:"relative"}}>
              {!isValid && 
                <Tooltip title="Invoice line unit value can't be negative or 0." color="#f88d8d">
                    <p className={"exclamation"}>!</p>
                </Tooltip>
              }  
              <FormR.Control 
                className={`editable-cell-input ${!isValid ? 'invalid-cell' : ''}`} 
                size="sm" 
                type="text" 
                defaultValue={record.invoice_line_unit_value} 
                onChange={(e)=>handleInvLineNumberChange(e)} 
                onBlur={(e) => handleInvLineUnitValueChange(e, record)}
              ></FormR.Control>
            </div>  
          );
        }
    },
    {
        title:"Line Total Exc",
        dataIndex:"invoice_line_total_exc",
        render: (text, record, index) => 
          <div>
            <FormR.Control className="editable-cell-input" size="sm" type="text" disabled defaultValue={record.invoice_line_total_exc}></FormR.Control>
          </div> 
    },
    {
        title:"Line Total Inc",
        dataIndex:"invoice_line_total_inc",
        render: (text, record, index) => 
          <div>
            <FormR.Control className="editable-cell-input" size="sm" type="text" disabled defaultValue={record.invoice_line_total_inc}></FormR.Control>
          </div> 
    },
    {
      title:"Line Notes",
      dataIndex:"invoice_line_notes",
      render: (text, record, index) =>  
      <div style={{display: "flex"}}>
        <Button size="sm" onClick={()=> onEditLineNotes(record)}>Notes</Button>
      </div> 
    },
    {
      title:"Line Document Link",
      dataIndex:"invoice_line_file",
      render: (text, record, index) => 
        <div style={{display: "flex"}}>
          {  record.invoice_line_file === "" || record.invoice_line_file === null || record.invoice_line_file=== "-"
              ? <p className="non-editable-cell">No File</p>
              : <a className="non-editable-cell" href={record.invoice_line_file} rel="noreferrer" target="_blank">View</a>
          }
          <img className="pencil-icon" src={require('./pencil.png')} alt="Not Found!" onClick={() => onEditDocumentLink(record)}/>
        </div>
    },
    {
      title:"Actions",
      render: (record) => <img className="delete-icon" src={require('./delete.png')} alt="Not Found!" onClick={() => handleInvoiceLineDeleteModalShow(record)}/>,
    }
    ];

    const InvoiceHeaderColumns =[
      {
          title:"Description",
          dataIndex:"invoice_description",
          render: (text, record, index) => {
            let isValid = true;
          
            if(record.invoice_description==="-"){
                isValid = false;
            }

            return(
            <div style={{minWidth: '150px', display: "flex", position:"relative"}}>
              {!isValid && 
                <Tooltip title="Invoice description can't be '-'." color="#f88d8d">
                    <p className={"exclamation"}>!</p>
                </Tooltip>
              }  
              <FormR.Control 
                className={`editable-cell-input ${!isValid ? 'invalid-cell' : ''}`}
                size="sm" 
                type="text" 
                defaultValue={record.invoice_description} 
                onBlur={(e) => handleInvDescriptionChange(e, record)}
              ></FormR.Control>
            </div> 
            );
          }
      },
      {
          title:"Create Date",
          dataIndex:"invoice_create_date",
          key: 'invoice_create_date',
          sorter: (a, b) => new Date(a.invoice_create_date) - new Date(b.invoice_create_date),
          render: (text, record, index) => 
            <div style={{maxWidth: '150px'}}>
              <FormR.Control className="editable-cell-input" size="sm" type="date" disabled={true} defaultValue={record.invoice_create_date} onBlur={(e) => handleInvCreateDateChange(e, record)}></FormR.Control>
            </div> 
      },
      {
          title:"Invoice Date",
          dataIndex:"invoice_date",
          key: "invoice_date",
          sorter: (a, b) => new Date(a.invoice_date) - new Date(b.invoice_date),
          defaultSortOrder: 'descend',
            render: (text, record, index) => {
              let isValid = true;
          
              if(record.invoice_date === null){
                  isValid = false;
              }

              return(
                <div style={{maxWidth: '150px', display: "flex", position:"relative"}}>
                  {!isValid && 
                    <Tooltip title="Invoice date can't be empty." color="#f88d8d">
                        <p className={"exclamation"}>!</p>
                    </Tooltip>
                  }  
                  <FormR.Control 
                    className={`editable-cell-input ${!isValid ? 'invalid-cell' : ''}`}
                    size="sm" 
                    type="date" 
                    defaultValue={record.invoice_date} 
                    onBlur={(e) => handleInvDateChange(e, record)}
                    required/>
                </div> 
              );
            }
      },
      {
          title:"Total Exc",
          dataIndex:"invoice_total_exc",
          render: (text, record, index) => {
            let isValid = true;
            
            if(parseFloat(record.invoice_total_exc) <= 0){
                isValid = false;
            }

            return(
              <div style={{minWidth: '100px', display: "flex", position:"relative"}}>
                {!isValid && 
                    <Tooltip title="Total can't be 0." color="#f88d8d">
                        <p className={"exclamation"}>!</p>
                    </Tooltip>
                  }  
                <p className="non-editable-cell">{record.invoice_total_exc}</p>
              </div> 
            )
          }
      },
      {
          title:"Total Inc",
          dataIndex:"invoice_total_inc",
          render: (text, record, index) => 
          <div style={{minWidth: '100px'}}>
          <p className="non-editable-cell">{record.invoice_total_inc}</p>
        </div> 
      },
      {
        title:"Sent",
        dataIndex:"invoice_sent",
        editable:true,
        filters: invoiceSentFilters,
        filterSearch: true,
        filteredValue: sentSelectedFilters,
        onFilter: (value, record) => (record.invoice_sent===true?"Yes":"No")===value,
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? 'blue' : '#000000',fontSize: '16px' }} />,
        render: (text, record) => 
            <div align="center">
                <Checkbox 
                    checked={record.invoice_sent}
                >
                </Checkbox>
            </div>
    
    },
    {
        title:"Paid",
        dataIndex:"invoice_paid",
        editable:true,
        filters: invoicePaidFilters,
        filterSearch: true,
        filteredValue: paidSelectedFilters,
        onFilter: (value, record) => (record.invoice_paid===true?"Yes":"No")===value,
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? 'blue' : '#000000',fontSize: '16px' }} />,
        render: (text, record) => 
            <div align="center">
                <Checkbox 
                    checked={record.invoice_paid}
                >
                </Checkbox>
            </div>
    },
      {
          title:"Date Paid",
          dataIndex:"invoice_date_paid",
          render: (text, record, index) => 
            <div style={{maxWidth: '150px'}}>
              <FormR.Control className="editable-cell-input" size="sm" type="date" disabled={true} defaultValue={record.invoice_date_paid} onBlur={(e) => handleInvDatePaidChange(e, record)}></FormR.Control>
            </div> 
      },
      {
          title:"Ref",
          dataIndex:"invoice_ref",
          render: (text, record, index) => 
          <div style={{minWidth: '100px'}}>
            <p className="non-editable-cell">{record.invoice_ref}</p>
          </div> 
            // <div style={{minWidth: '100px'}}>
            //   <FormR.Control className="non-editable-cell" size="sm" type="text" value={record.invoice_ref}></FormR.Control>
            // </div> 
      },
      {
          title:"Notes",
          dataIndex:"invoice_notes",
          render: (text, record, index) =>  <div style={{display: "flex"}}>
                                              <Button size="sm" onClick={()=> onEditNotes(record)}>Notes</Button>
                                            </div>
      },
      {
          title:"Send Invoice",
          render: (record) => 
              <Button
                  onClick={() => handleSendInvHeaderModalShow(record)}
                  variant="outline-success"
              >
                  Save & Send Request
              </Button>
      },
      {
          title:"Actions",
          render: (record) => <img className="delete-icon" src={require('./delete.png')} alt="Not Found!" onClick={() => handleDeleteInvHeaderModalShow(record)}/>,
      }
    ];
    //#endregion

    //#region Ant Table States & Functions

    const EditableContext = React.createContext(null);

    const EditableRow = ({ index, ...props }) => {
    const [form] = Form.useForm();
    return (
        <Form form={form} component={false}>
        <EditableContext.Provider value={form}>
            <tr {...props} />
        </EditableContext.Provider>
        </Form>
    );
    };

    const EditableCell = ({
    title,
    editable,
    children,
    dataIndex,
    record,
    handleSave,
    ...restProps
    }) => {
    const [editing, setEditing] = useState(false);
    const inputRef = useRef(null);
    const form = useContext(EditableContext);
    useEffect(() => {
        if (editing) {
        inputRef.current.focus();
        }
    }, [editing]);
    const toggleEdit = () => {
        setEditing(!editing);
        form.setFieldsValue({
        [dataIndex]: record[dataIndex],
        });
    };
    const save = async () => {
        try {
        const values = await form.validateFields();
        toggleEdit();
        onTableDataChange(true);
        handleSave({
            ...record,
            ...values,
        });
        } catch (errInfo) {
        console.log('Save failed:', errInfo);
        }
    };
    let childNode = children;
    if (editable) {
        childNode = editing ? (
        <Form.Item
            style={{margin: 0,}}
            name={dataIndex}
            rules={[
              {required: ((
                dataIndex === "invoice_notes" || 
                dataIndex === "invoice_line_notes" || 
                dataIndex === "invoice_line_file") ? false : true ), message: `${title} is required.`}
            ]}
        >
            <Input ref={inputRef} onPressEnter={save} onBlur={save} />
        </Form.Item>
        ) : (
        <div
            className="editable-cell-value-wrap"
            style={{
            paddingRight: 24,
            }}
            onClick={toggleEdit}
        >
            {children}
        </div>
        );
    }
    return <td {...restProps}>{childNode}</td>;
    };

    const components = {
    body: {
        row: EditableRow,
        cell: EditableCell,
    },
    };

    const invHeadercolumns = InvoiceHeaderColumns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
            record,
            editable: col.editable,
            dataIndex: col.dataIndex,
            title: col.title,
            handleSave,
            }),
        };
    });

    const invLinecolumns = InvoiceLineColumns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
            record,
            editable: col.editable,
            dataIndex: col.dataIndex,
            title: col.title,
            handleSave,
            }),
        };
    });

    //#endregion

    //#region Functions

    function populateUI()
    {
        try 
        {
          AxiosHelper.makeAxiosRequest("Read", "Customer", "GetCustomerList", null, null)
          .then((response) => 
          {
            let customerOptionsArray = [];

            response.data.forEach(customer => 
            {
              customerOptionsArray.push({id: customer.CustId, value: customer.CustName});
              if (customer.id === proposal.CustId) 
              {
                //SetCustomerDefaultOption({id: customer.CustId, value: customer.CustName});    
              }
            });

            setCustomerOptions(customerOptionsArray);

            AxiosHelper.makeAxiosRequest("Read", "Config", "GetConfigItem", {Description: 'Vat'}, null)
            .then((response)=>
            {
              SetVat(response.data.businessConfigValue);
            })
            .catch((error)=>
            {
              console.log(error)
            });

          })
          .catch((e)=>
          {
              console.log('ERROR!');
          });

          AxiosHelper.makeAxiosRequest("Read", "FrequencyType", "GetFrequencyTypes", null, null)
          .then((response) => 
          {
              let frequencyTypeOptionsArray = [];

              response.data.forEach(frequencyType => 
              {
                frequencyTypeOptionsArray.push({id: frequencyType.FreqTypeId, value: frequencyType.FreqTypeDescription});
              });
              setFrequencyTypeOptions(frequencyTypeOptionsArray);

          })
          .catch((e)=>
          {
              console.log('ERROR!');
          });

          if (proposalId !== 0 && proposalId !== null) 
          {
            AxiosHelper.makeAxiosRequest("Read", "Proposal", "GetProposal", {proposalId: proposalId}, null)
            .then((response) => 
            {
              setProposal({
                CustId: response.data.CustId,
                PropId: response.data.PropId,
                PropName: response.data.PropName,
                PropDateFrom:response.data.PropDateFrom.substring(0,10),
                PropDateTo: response.data.PropDateTo.substring(0,10),
                PropUnitQty: response.data.PropUnitQty,
                PropUnitValue: response.data.PropUnitValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),
                PropSubTotalExc: response.data.PropSubTotalExc.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),
                PropSubTotalInc: response.data.PropSubTotalInc.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),
                PropTotalExc: response.data.PropTotalExc.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),
                PropTotalInc: response.data.PropTotalInc.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),
                PropFreqType: response.data.PropFreqType,
                PropFreqQty: response.data.PropFreqQty,
                PropStatus: response.data.PropStatus,
                PropNotes: response.data.PropNotes,
                PropFileLink: response.data.PropFileLink
              })
              
              let tempInvoiceData = [];
              //let tempProp = {};
              let tempInvoiceHeader={};
              let tempInvoiceLine = {};

              response.data.InvHeader.forEach(header=>
              {
                tempInvoiceHeader = 
                {
                  key:header.InvId,
                  invoice_description:header.InvDesc,
                  invoice_create_date:header.InvCreateDate.substring(0,10),
                  invoice_date:header.InvDate.substring(0,10),
                  invoice_total_exc:header.InvTotalExc.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),
                  invoice_total_inc:header.InvTotalInc.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),
                  invoice_sent:header.InvSent,
                  invoice_paid:header.InvPaid,
                  invoice_date_paid:header.InvDatePaid===null?null:header.InvDatePaid.substring(0,10),
                  invoice_ref:header.InvRef,
                  invoice_notes:header.InvNotes,
                  invoice_type:'server',
                  invoiceLines:[]
                }
                
                header.InvLine.forEach(line=>
                {
                  tempInvoiceLine = 
                  {
                    key:line.InvLineId,
                    invoice_line_headId:header.InvId,
                    invoice_line_description:line.InvLineDesc,
                    invoice_line_quantity:line.InvLineUnitQty,
                    invoice_line_unit_value:line.InvLineUnitValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),
                    invoice_line_total_exc:line.InvLineTotalExc.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),
                    invoice_line_total_inc:line.InvLineTotalInc.toString().replace(/\B(?=(\d{3})+(?!\d))/g,','),
                    invoice_line_notes:line.InvLineNotes,
                    invoice_line_file: line.InvLineFileLink,
                    invoice_line_type:'server',
                  }
                  tempInvoiceHeader.invoiceLines.push(tempInvoiceLine);
                });
                tempInvoiceData.push(tempInvoiceHeader)
              });

              setInvoiceData(tempInvoiceData);
                      

              })
              .then(()=>
                AxiosHelper.makeAxiosRequest("Read", "Config", "GetConfigItem", {Description: 'Vat'}, null))
                .then((response)=>
                {
                  SetVat(response.data.businessConfigValue);
                })
              .catch(error => {
                  console.log(error);
              });

              setSubNavValues([]);

              AxiosHelper.makeAxiosRequest("Read", "Summary", "GetRelatedCustomer", {proposalID : proposalId}, null)
              .then((response) => {
                  setSubNavValues(oldSubNavValues => [...oldSubNavValues, {heading: "Customer", text: response.data.value}] );

                  AxiosHelper.makeAxiosRequest("Read", "Proposal", "GetProposal", {proposalId : proposalId})
                  .then((response) => 
                  {
                    setSubNavValues(oldSubNavValues => [...oldSubNavValues, {heading: "Proposal Name", text: response.data.PropName}] );

                  AxiosHelper.makeAxiosRequest("Read", "Summary", "GetRelatedAccountManager", {proposalID : proposalId}, null)
                  .then((response) => {
                      setSubNavValues(oldSubNavValues => [...oldSubNavValues, {heading: "Account Manager", text: response.data.value}] );
                  })

                  })

                  
              })
              .catch(error => {
                  console.log(error);
              });    
          }
        } 
        catch (error) 
        {
          console.log(error);
        }
    }

      //#region InvHeader Handle Change Functions

      const handleInvDescriptionChange = (e, row) => {
        
        if (row.invoice_description !== e.target.value) 
        {
          row.invoice_description = e.target.value;
          handleSave(row);
          onTableDataChange(true);
        }

      }

      const handleInvCreateDateChange = (e, row) => {
        
        if (row.invoice_create_date !== e.target.value) 
        {
          row.invoice_create_date = e.target.value;
          handleSave(row);
          onTableDataChange(true);
        }
        
      }

      const handleInvDateChange = (e, row) => {

        if (row.invoice_date !== e.target.value) 
        {
          row.invoice_date = e.target.value;
          handleSave(row);
          onTableDataChange(true);
        }

      }

      const handleInvDatePaidChange = (e, row) => {

        if (row.invoice_date_paid !== e.target.value) 
        {
          row.invoice_date_paid = e.target.value;
          handleSave(row);
          onTableDataChange(true);
        }

      }

      //#endregion

      const handleEditDocumentLinkModalClose = () =>{
        setEditDocumentLinkShow(false);
      }
  
  
      const handleEditDocumentLinkModalShow = () =>{
        setEditDocumentLinkShow(true);
      }
  
      const onEditDocumentLink = (invoiceLine) =>{
        setSelectedDocumentLink(invoiceLine);
        setNewSelectedDocumentLink(invoiceLine.invoice_line_file);
        handleEditDocumentLinkModalShow();
      }
  
      const onEditDocumentLinkModalSave = () =>{ 
        if(selectedDocumentLink.invoice_line_file === newSelectedDocumentLink){
          handleEditDocumentLinkModalClose();
          notifySuccessful("No changes have been made");
        }else{
          selectedDocumentLink.invoice_line_file = newSelectedDocumentLink;
          handleSave(selectedDocumentLink);
          onTableDataChange(true);
          handleEditDocumentLinkModalClose();
        }
      }
      //#region InvHeader Handle Change Functions

      const handleInvLineDescriptionChange = (e, row) => {

        if (row.invoice_line_description !== e.target.value) 
        {
          row.invoice_line_description = e.target.value;
          handleSave(row);
          onTableDataChange(true);
        }

      }


      const handleInvLineNumberChange = (e)=>{
        e.target.value = e.target.value.replace(/[^0-9\.]/g,'')
        e.target.value = e.target.value.replace(/\B(?=(\d{3})+(?!\d))/g,',')
      }

      const handleInvLineQuantityChange = (e, row) => {

        // non strict check to avoid changes notification when int !== float 
        if (row.invoice_line_quantity !== e.target.value) 
        {
          row.invoice_line_quantity = e.target.value;
          handleSave(row);
          onTableDataChange(true);
        }

      }

      const handleInvLineUnitValueChange = (e, row) => {

        // non strict check to avoid changes notification when int !== float 
        if (row.invoice_line_unit_value !== e.target.value) 
        {
          row.invoice_line_unit_value = e.target.value.replace(/\B(?=(\d{3})+(?!\d))/g,',');
          console.log(e.target.value)
          handleSave(row);
          onTableDataChange(true);
        }

      }
      
      //#endregion

    const notifySuccessful = (message) => {
        toast.success(message, {
          position: "bottom-center",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
    };
    
    const notifyFailed = (message) => {
        toast.error(message, {
            position: "bottom-center",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    };

    const notifyChanges = (message) => {
      toast.warning(message, {
          toastId: "ToastDataTableWarning",
          position: "top-right",
          autoClose: false,
          closeOnClick: true,
          draggable: false,
          progress: undefined,
          closeButton: true
        });
      };
    
    const handleSave = (row) => {
      if(row.hasOwnProperty('invoiceLines'))
      {
      // assign appropriate default values when only spaces are entered to prevent editable cell from dissapearing

        for (const key in row) 
        {
          let keyValue = String(row[key]);

          switch (key) {
            case "invoice_description":
              if (!keyValue.replace(/\s/g, '').length) 
                {
                  row[key] = "-";
                }
              break;

            case "invoice_create_date":
              if (!keyValue.replace(/\s/g, '').length) 
                {
                  let date = new Date();
                  let datestring = new Date(date.getTime() - (date.getTimezoneOffset() * 60000 )).toISOString().split("T")[0];

                  row[key] = datestring;
                }
              break;

            case "invoice_date":
              if (!keyValue.replace(/\s/g, '').length) 
                {
                  let date = new Date();
                  let datestring = new Date(date.getTime() - (date.getTimezoneOffset() * 60000 )).toISOString().split("T")[0];

                  row[key] = datestring;
                }
              break;

            case "invoice_sent":
              if (!keyValue.replace(/\s/g, '').length) 
                {
                  row[key] = "No";
                }
              break;

            case "invoice_paid":
              if (!keyValue.replace(/\s/g, '').length) 
                {
                  row[key] = "No";
                }
              break;

            case "invoice_date_paid":
              if (!keyValue.replace(/\s/g, '').length) 
                {
                  let date = new Date();
                  let datestring = new Date(date.getTime() - (date.getTimezoneOffset() * 60000 )).toISOString().split("T")[0];

                  row[key] = datestring;
                }
              break;

            case "invoice_ref":
              if (!keyValue.replace(/\s/g, '').length) 
                {
                  row[key] = "-";
                }
              break;
          
            case "invoice_notes":
              if (!keyValue.replace(/\s/g, '').length) 
                {
                  row[key] = "-";
                }
              break;
          
            default:
              break;
          }

        }

        const newData = [...invoiceData];
        const index = newData.findIndex((item) => row.key === item.key);
        const item = newData[index];
        newData.splice(index, 1, 
          {
            ...item,
            ...row,
          }
        );
        setInvoiceData(newData);
      }
      else {
        // assign appropriate default values when only spaces are entered to prevent editable cell from dissapearing

        for (const key in row) 
        {

          let keyValue = String(row[key]);

          switch (key) {
            case "invoice_line_description":
              if (!keyValue.replace(/\s/g, '').length) 
                {
                  row[key] = "-";
                }
              break;

            case "invoice_line_quantity":
            if (!keyValue.replace(/\s/g, '').length) 
              {
                row[key] = 0;
              }
            break;

            case "invoice_line_unit_value":
            if (!keyValue.replace(/\s/g, '').length) 
              {
                row[key] = 0;
              }
            break;

            case "invoice_line_notes":
              if (!keyValue.replace(/\s/g, '').length) 
                {
                  row[key] = "-";
                }
              break;

            case "invoice_line_file":
              if (!keyValue.replace(/\s/g, '').length) 
                {
                  row[key] = "-";
                }
              break;
          
            default:
              break;
          }
          
        }

        let newData = [...invoiceData];
        const index = newData.findIndex((item) => row.invoice_line_headId === item.key);
        const lineIndex = newData[index].invoiceLines.findIndex((itemline) => row.key===itemline.key);
        let item = newData[index].invoiceLines[lineIndex];
        let totalExc = row.invoice_line_quantity * Number(row.invoice_line_unit_value.toString().replace(/(,)/g,''));
        
        row.invoice_line_total_exc = row.invoice_line_quantity *  Number(row.invoice_line_unit_value.toString().replace(/(,)/g,''));
        row.invoice_line_total_inc = totalExc + (totalExc * vat);
        row.invoice_line_total_inc = row.invoice_line_total_inc.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');

        item.invoice_line_total_exc = totalExc.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');
        newData[index].invoiceLines.splice(lineIndex, 1, {
        ...item,
        ...row,
        });
        setInvoiceData(newData);

        //Calculate invoice header total
        let  headerTotalExc = 0;
        let  headerTotalInc = 0;
        newData[index].invoiceLines.forEach(line=>{
            headerTotalExc =  Number(headerTotalExc.toString().replace(/\B(,)/g,','))+Number(line.invoice_line_total_exc.toString().replace(/(,)/g,''));
            headerTotalInc = headerTotalInc+Number(line.invoice_line_total_inc.toString().replace(/(,)/g,''))
        });
        console.log(headerTotalExc)
        newData[index].invoice_total_exc=headerTotalExc.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');
        newData[index].invoice_total_inc=headerTotalInc.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');
        setInvoiceData(newData);
      }
    };

    function GetNewRowKey(listItems){
        let biggestKey = 0;
        listItems.forEach(element => {
            if(element.key>biggestKey){
                biggestKey=element.key;
            }
        });
        biggestKey = biggestKey+1;
        return biggestKey;
    }

    const handleInvoiceHeaderAdd = () => {
      onTableDataChange(true);
      let newRowKey = GetNewRowKey(invoiceData);

      let date = new Date();
      let datestring = new Date(date.getTime() - (date.getTimezoneOffset() * 60000 )).toISOString().split("T")[0];
      const newData = {
          key: newRowKey,
          invoice_description:"-",
          proposal_id:proposalId,
          invoice_create_date: datestring,
          invoice_date: null,
          invoice_total_exc:0,
          invoice_total_inc:0,
          invoice_sent:false,
          invoice_paid:false,
          invoice_date_paid: null,
          invoice_ref:"-",
          invoice_notes:"-",
          invoice_type:'client',
          invoiceLines:[]
      };
      setInvoiceData([...invoiceData, newData]);
    };

    const handleInvoiceLineAdd = (dataSource) => {
        onTableDataChange(true);
        //let recordKey = 0;
        //let invoiceIndex = 0;
        if(dataSource.invoiceLines.length===0){
            const newData = {
              key: 1,
              invoice_line_description:"-",
              invoice_line_headId:dataSource.key,
              invoice_line_quantity: 0,
              invoice_line_unit_value: 0,
              invoice_line_total_exc:0,
              invoice_line_total_inc:0,
              invoice_line_notes:"-",
              invoice_line_file: "-",
              invoice_line_type:'client',
            };
            //setPageEdited(true);
            const newLines = [...dataSource.invoiceLines];
            newLines.push(newData);

            const newState = invoiceData.map(invoiceHeader => {
                if (invoiceHeader.key === dataSource.key) {
                    return {...invoiceHeader, invoiceLines: newLines};
                }
                return invoiceHeader;
                });
                setInvoiceData(newState);
        }
        else{
          let newRowKey = GetNewRowKey(dataSource.invoiceLines);
          const newData = {
            key: newRowKey,
            invoice_line_description:"-",
            invoice_line_headId:dataSource.key,
            invoice_line_quantity: 0,
            invoice_line_unit_value: 0,
            invoice_line_total_exc:0,
            invoice_line_total_inc:0,
            invoice_line_notes:"-",
            invoice_line_file: "-",
            invoice_line_type:'client',
          };
          const newLines = [...dataSource.invoiceLines];

          newLines.push(newData);

          const newState = invoiceData.map(invoiceHeader => {
              if (invoiceHeader.key === dataSource.invoiceLines[0].invoice_line_headId) {
                  return {...invoiceHeader, invoiceLines: newLines};
              }
              return invoiceHeader;
              });
          setInvoiceData(newState);
        }        
    };

    function SaveTable()
    {
      try 
      {        
        let tableValid = true;
        invoiceData.forEach(header => {
          if (header.invoice_date === null) {
            tableValid = false;
          }
          if(header.invoiceLines.length===0)
            {
              tableValid = false
            }
            else if (header.invoice_date === null) 
            {
              tableValid = false;
            }
            header.invoiceLines.forEach(line => {
              if(line.invoice_line_description==='-'){
                tableValid = false
              }
              if(line.invoice_line_total_exc===0){
                tableValid = false
              }
            });
        })

        if (tableValid) {
          saveInvoiceHeader(invoiceData)

          notifySuccessful("Changes saved successfully");
          setTimeout(() => 
          {
            window.location.reload();
          }, 2000);
        } else {
          notifyFailed("Please complete all Invoice details! Header cannot be saved without Line.");
        }
        

      } catch (errInfo) {
          console.log('Validate Failed:', errInfo);
      }
    };
    
    function onCreateProposalChange(event)
    {
        event.target.form.CreatePropUnitValue.value = event.target.form.CreatePropUnitValue.value.toString().replace(/(,)/g,'').replace(/\B(?=(\d{3})+(?!\d))/g,',')
        event.target.form.CreatePropSubTotalExc.value = (event.target.form.CreatePropUnitQty.value * event.target.form.CreatePropUnitValue.value.toString().replace(/(,)/g,'')).toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');
        let vatSubTotalAmountExc = ((event.target.form.CreatePropSubTotalExc.value.toString().replace(/(,)/g,'') * vat));
        event.target.form.CreatePropSubTotalInc.value = (parseFloat(event.target.form.CreatePropSubTotalExc.value.toString().replace(/(,)/g,'')) + vatSubTotalAmountExc).toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');
        event.target.form.CreatePropTotalExc.value = (event.target.form.CreatePropSubTotalExc.value.toString().replace(/(,)/g,'') * event.target.form.CreatePropFreqQty.value.toString().replace(/(,)/g,'')).toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');
        let varTotalExcamount = event.target.form.CreatePropTotalExc.value.toString().replace(/(,)/g,'') * vat;
        event.target.form.CreatePropTotalInc.value = (parseFloat(event.target.form.CreatePropTotalExc.value.toString().replace(/(,)/g,''))+varTotalExcamount).toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');
    }

    //CREATE
    function onProposalCreateFormSubmitHandler(event)
    {
        event.preventDefault();

        const form = event.currentTarget;
            if (form.checkValidity() === false) 
            {
              event.preventDefault();
              event.stopPropagation();
            }
            else
            {
              let PropSubTotalExc = event.target.elements.CreatePropUnitQty.value.toString().replace(/(,)/g,'') * event.target.elements.CreatePropUnitValue.value.toString().replace(/(,)/g,'');
              let PropTotalExc = Number(PropSubTotalExc * event.target.elements.CreatePropFreqQty.value.toString().replace(/(,)/g,''));

              let createProposal = {
                  CustId: parseInt(event.target.elements.CreatePropCustomer.value),
                  PropName: event.target.elements.CreatePropName.value,
                  PropDateFrom: event.target.elements.CreatePropDateFrom.value.substring(0,10),
                  PropDateTo: event.target.elements.CreatePropDateTo.value.substring(0,10),
                  PropUnitQty: parseInt(event.target.elements.CreatePropUnitQty.value),
                  PropUnitValue: parseInt(event.target.elements.CreatePropUnitValue.value.toString().replace(/(,)/g,'')),
                  PropSubTotalExc: parseFloat(PropSubTotalExc.toString().replace(/(,)/g,'')),
                  PropSubTotalInc: parseFloat(PropSubTotalExc+(PropSubTotalExc*vat)),
                  PropFreqQty: parseInt(event.target.elements.CreatePropFreqQty.value),
                  PropFreqType: parseInt(event.target.elements.CreatePropFreqType.value),
                  PropTotalExc: parseFloat(PropTotalExc),
                  PropTotalInc: parseFloat(PropTotalExc+(PropTotalExc*vat)),
                  PropFileLink: event.target.elements.CreatePropFileLink.value,
                  PropNotes: event.target.elements.CreatePropNotes.value,
                  PropStatus: 'Active'
                  };

                AxiosHelper.makeAxiosRequest("Create", "Proposal", "CreateNewProposal", {currentUserId : loggedInUser}, createProposal)
                .then((response) => {
                    notifySuccessful("Proposal Created!");
                    setTimeout(function () {
                      let detail = parseInt(event.target.elements.CreatePropCustomer.value);
                      //navigate('/home');
                      navigate('/home',{state: detail});
                    }, 2000);
                    console.log('The response:');
                    console.log(response);
                    // Implement when email is available
                    //sendEmail(createProposal);
                })
                .catch(error => {
                  console.log(error);
                  if(error.message==='Network Error'){
                      notifyFailed("A Network Error Occured, Please Try Again.");
                  }
                  else{
                    notifyFailed("An Error Occured, Please Try Again.");
                  }
                });
            }

            setIsCreateValidated(true);
    }

    function onInvoiceDelete(deleteInvoice)
    {
        let invoiceDataCopy = [...invoiceData];
        let deleteInvoiceIndex = invoiceDataCopy.findIndex(x => x.key === deleteInvoice.key);

        if (deleteInvoice.invoice_type === "server") 
        {
          AxiosHelper.makeAxiosRequest("Delete", "InvHeaders", "DeleteInvoiceHeader", {invoiceId : deleteInvoice.key, currentUserId: loggedInUser})
          .then((response) => {

              if (response.data === "Invoice Deleted") 
              {
                invoiceDataCopy.splice(deleteInvoiceIndex, 1);
                setInvoiceData(invoiceDataCopy);
                notifySuccessful("Invoice Deleted!");
                handleDeleteInvHeaderModalClose(); 
              }
              else
              {
                notifyFailed("Invoice has invoice lines loaded.");
                handleDeleteInvHeaderModalClose();
              }
              
          })
          .catch(error => {
              console.log(error);
              notifyFailed("An Error Occurred, Please Try Again.");
              handleDeleteInvHeaderModalClose();
          });  
        } 
        else 
        {
          if (deleteInvoice.invoiceLines.length > 0) 
          {
            notifyFailed("Invoice has invoice lines loaded.");
            handleDeleteInvHeaderModalClose();
          } 
          else 
          {
            invoiceDataCopy.splice(deleteInvoiceIndex, 1);
            setInvoiceData(invoiceDataCopy);
            notifySuccessful("Invoice Deleted!");
            handleDeleteInvHeaderModalClose();
          }
        }
    };
    
    function onInvoiceLineDelete(deleteInvoiceLine)
    {
        let invoiceDataCopy = [...invoiceData];
        let invoiceIndex = invoiceDataCopy.findIndex(x => x.key === deleteInvoiceLine.invoice_line_headId);
        let deleteInvoiceLineIndex = invoiceDataCopy[invoiceIndex].invoiceLines.findIndex(x => x.key === deleteInvoiceLine.key);

        if (deleteInvoiceLine.invoice_line_type === "server") 
        {
          AxiosHelper.makeAxiosRequest("Delete", "InvHeaders", "DeleteInvoiceLine", {invoiceLineId: deleteInvoiceLine.key, currentUserId: loggedInUser}, null)
          .then((response) => {
              invoiceDataCopy[invoiceIndex].invoiceLines.splice(deleteInvoiceLineIndex, 1);
              //Calculate invoice header total
              let  headerTotalExc = 0;
              let  headerTotalInc = 0;
              invoiceDataCopy[invoiceIndex].invoiceLines.forEach(line=>{
                  headerTotalExc= Number(headerTotalExc.toString().replace(/(,)/g,''))+Number(line.invoice_line_total_exc.toString().replace(/(,)/g,''));
                  headerTotalInc=Number(headerTotalInc.toString().replace(/(,)/g,''))+Number(line.invoice_line_total_inc.toString().replace(/(,)/g,''))
              });

              invoiceDataCopy[invoiceIndex].invoice_total_exc=headerTotalExc.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');
              invoiceDataCopy[invoiceIndex].invoice_total_inc=headerTotalInc.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');

              setInvoiceData(invoiceDataCopy);
              saveInvoiceHeader(true);
              notifySuccessful("Invoice Line Deleted!");
              handleInvoiceLineDeleteModalClose();

          })
          .catch(error => {
              console.log(error);
              notifyFailed("An Error Occurred, Please Try Again.");
              handleInvoiceLineDeleteModalClose();
          });  
        } 
        else 
        {
            invoiceDataCopy[invoiceIndex].invoiceLines.splice(deleteInvoiceLineIndex, 1);
            
            //Calculate invoice header total
            let  headerTotalExc = 0;
            let  headerTotalInc = 0;
            invoiceDataCopy[invoiceIndex].invoiceLines.forEach(line=>{
                headerTotalExc= Number(headerTotalExc.toString().replace(/(,)/g,''))+Number(line.invoice_line_total_exc.toString().replace(/(,)/g,''));
                headerTotalInc=Number(headerTotalInc.toString().replace(/(,)/g,''))+Number(line.invoice_line_total_inc.toString().replace(/(,)/g,''))
            });

            invoiceDataCopy[invoiceIndex].invoice_total_exc=headerTotalExc.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');
            invoiceDataCopy[invoiceIndex].invoice_total_inc=headerTotalInc.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');

            setInvoiceData(invoiceDataCopy);
            notifySuccessful("Invoice Line Deleted!");
            handleInvoiceLineDeleteModalClose();
        }        
    };

    function saveInvoiceHeader(deleted = false) {
      try {
        let postedData = [];
        let tempHeader={}
        invoiceData.forEach(header=>{
          console.log("InvHeader")
          console.log(header)
          tempHeader = {
              InvId : header.key,
              InvDesc:header.invoice_description,
              PropId :parseInt(proposalId),
              InvCreateDate:header.invoice_create_date,
              InvDate:header.invoice_date.substring(0,10),
              InvTotalExc:parseFloat(header.invoice_total_exc.toString().replace(/(,)/g,'')),
              InvTotalInc:parseFloat(header.invoice_total_inc.toString().replace(/(,)/g,'')),
              InvSent:header.invoice_sent,
              InvPaid:header.invoice_paid,
              InvDatePaid:header.invoice_date_paid === null ? null : header.invoice_date_paid.substring(0,10),
              InvRef:header.invoice_ref,
              InvNotes:header.invoice_notes,
              InvHeaderType:header.invoice_type,
              InvLine:[]
          }

          console.log("InvLines")
          console.log(header.invoiceLines)
          header.invoiceLines.forEach(line => 
          {
            console.log("InvLine:")
            console.log(line)
            let tempLine={
              InvLineId:line.key,
              InvId:parseInt(line.key),
              InvLineDesc:line.invoice_line_description,
              InvLineUnitQty:parseFloat(line.invoice_line_quantity.toString().replace(/(,)/g,'')),
              InvLineUnitValue:parseFloat(line.invoice_line_unit_value.toString().replace(/(,)/g,'')),
              InvLineTotalExc:parseFloat(line.invoice_line_total_exc.toString().replace(/(,)/g,'')),
              InvLineTotalInc:parseFloat(line.invoice_line_total_inc.toString().replace(/(,)/g,'')),
              InvLineNotes:line.invoice_line_notes,
              InvLineFileLink:line.invoice_line_file,
              InvLineType:line.invoice_line_type
            }
            tempHeader.InvLine.push(tempLine);
          });
          console.log("TEMP HEADER")
          console.log(tempHeader)
          postedData.push(tempHeader);
        })
        
        
        AxiosHelper.makeAxiosRequest("Create", "InvHeaders", "CreateInvoiceHeader", {currentUserId : loggedInUser}, postedData)
        .then(()=>{
          if(!deleted){
            toast.dismiss();
            notifySuccessful("Changes saved!");
          }
        })
        .catch((Error)=>{
          if(Error === 'ValidationError'){
            console.log(Error);
          }
          console.log(Error);
          notifyFailed("Please complete all Invoice details! Header cannot be saved without Line.")
        });
        

      } catch (errInfo) {
          console.log('Validate Failed:', errInfo);
      }
    }

    function onCancelChanges()
    {
      if(proposalId!==0){
        AxiosHelper.makeAxiosRequest("Read", "Proposal", "GetProposal" , {proposalId : proposalId}, null)
        .then((response) => {
            let tempInvoiceData = [];
            let tempInvoiceHeader={};
            let tempInvoiceLine = {};
          response.data.InvHeader.forEach(header=>{
                  tempInvoiceHeader = {key:header.InvId,
                      invoice_description:header.InvDesc,
                      invoice_create_date:header.InvCreateDate.substring(0,10),
                      invoice_date:header.InvDate.substring(0,10),
                      invoice_total_exc:header.InvTotalExc.toFixed(2),
                      invoice_total_inc:header.InvTotalInc.toFixed(2),
                      invoice_sent:header.InvSent,
                      invoice_paid:header.InvPaid,
                      invoice_date_paid:header.InvDatePaid===null?null:header.InvDatePaid.substring(0,10),
                      invoice_ref:header.InvRef,
                      invoice_notes:header.InvNotes,
                      invoice_type:'server',
                      invoiceLines:[]
              }
              header.InvLine.forEach(line=>{
                  tempInvoiceLine = {key:line.InvLineId,
                      invoice_line_headId:header.InvId,
                      invoice_line_description:line.InvLineDesc,
                      invoice_line_quantity:line.InvLineUnitQty,
                      invoice_line_unit_value:line.InvLineUnitValue.toFixed(2),
                      invoice_line_total_exc:line.InvLineTotalExc.toFixed(2),
                      invoice_line_total_inc:line.InvLineTotalInc.toFixed(2),
                      invoice_line_notes:line.InvLineNotes,
                      invoice_line_file: line.InvLineFileLink,
                      invoice_line_type:'server',}
                  tempInvoiceHeader.invoiceLines.push(tempInvoiceLine);
              });
              tempInvoiceData.push(tempInvoiceHeader)
          });
          setInvoiceData(tempInvoiceData);
                onTableDataChange(false);
          notifySuccessful("Changes Successfully Cleared!");
          handleCancelModalClose();
      })
      .catch(error => {
          console.log(error);
          notifyFailed("Failed To Clear Changes.");
      });  
      }
      else{
        notifySuccessful("Clearing changes...");
        setTimeout(() => {
          navigate('/home');
        }, 2000);     
        
      }
         
    }

    function onCancelProposalChanges()
    {
      console.log(eventToChange)
      eventToChange.target.form.PropName.value = proposal.PropName
      eventToChange.target.form.UpdatePropCustomer.value = proposal.CustId
      eventToChange.target.form.PropDateFrom.value = proposal.PropDateFrom
      eventToChange.target.form.PropDateTo.value = proposal.PropDateTo
      eventToChange.target.form.PropUnitQty.value = proposal.PropUnitQty
      eventToChange.target.form.PropUnitValue.value = proposal.PropUnitValue
      eventToChange.target.form.PropFreqType.value = proposal.PropFreqType
      eventToChange.target.form.PropFreqQty.value = proposal.PropFreqQty
      eventToChange.target.form.PropSubTotalExc.value = proposal.PropSubTotalExc
      eventToChange.target.form.PropSubTotalInc.value = proposal.PropSubTotalInc
      eventToChange.target.form.PropTotalExc.value = proposal.PropTotalExc
      eventToChange.target.form.PropTotalInc.value = proposal.PropTotalInc
      eventToChange.target.form.PropStatus.value = proposal.PropStatus
      eventToChange.target.form.PropFileLink.value = proposal.PropFileLink
      eventToChange.target.form.PropNotes.value = proposal.PropNotes


      notifySuccessful("Changes Successfully Cleared!");
      handleCancelPropModalClose(); 
    }

    const handleCancelModalClose = () => setCancelModalShow(false);
    const handleCancelModalShow = () => setCancelModalShow(true);
    const handleBackClick = () =>{
      navigate('/home');
    }

    const onChange = (page,filter,sorter) => {
      setSentSelectedFilters(filter.invoice_sent);
      setPaidSelectedFilters(filter.invoice_paid);
  };   

    const handleCancelPropModalClose = () => setCancelPropModalShow(false);
  
    const handleDeleteInvHeaderModalClose = () => setDeleteInvHeaderModalShow(false);

    function handleDeleteInvHeaderModalShow(invoiceRecord)
    {
        setSelectedDeleteInvoice(invoiceRecord);
        setDeleteInvHeaderModalShow(true);
    }

    const handleInvoiceLineDeleteModalClose = () => setInvoiceLineDeleteModalShow(false);

    function handleInvoiceLineDeleteModalShow(invLineRecord)
    {
        setSelectedInvoiceLineDelete(invLineRecord);
        setInvoiceLineDeleteModalShow(true);
    }
    function NavigateToLogin(){
      navigate('/login');
    }
      
    function onTableDataChange(isDirty)
    {
      if (isDirty) 
      {
        notifyChanges("Data table contains unsaved changes.");
      }
      else
      {
        toast.dismiss();
      }
    }

    //Header notes management
    const handleEditNotesShowModalClose = () =>{
      setEditNotesShow(false);
    } 

    const handleEditNotesModalShow = () =>{
      setEditNotesShow(true);
    }

    const onEditNotes = (invoice) =>{
      setSelectedNotes(invoice);
      setNewSelectedNotes(invoice.invoice_notes);
      handleEditNotesModalShow();
    }

    const onEditNotesModalSave = () =>{
      if(selectedNotes.invoice_notes === newSelectedNotes){
        handleEditNotesShowModalClose();
        notifySuccessful("No changes have been made.");
      }else{
        selectedNotes.invoice_notes = newSelectedNotes;
        handleSave(selectedNotes);
        onTableDataChange(true);
        handleEditNotesShowModalClose();
      }
    }  
    
    //Line notes management
    
    const handleEditLineNotesShowModalClose = () =>{
      setEditLineNotesShow(false);
    } 

    const handleEditLineNotesModalShow = () =>{
      setEditLineNotesShow(true);
    }

    const onEditLineNotes = (invoiceLine) =>{
      setSelectedLineNotes(invoiceLine);
      setNewSelectedLineNotes(invoiceLine.invoice_line_notes);
      handleEditLineNotesModalShow();
    }

    const onEditLineNotesModalSave = () =>{
      if(selectedLineNotes.invoice_line_notes === newSelectedLineNotes){
        handleEditLineNotesShowModalClose();
        notifySuccessful("No changes have been made.");
      }else{
        selectedLineNotes.invoice_line_notes = newSelectedLineNotes;
        console.log(selectedLineNotes);
        console.log(newSelectedLineNotes);
        handleSave(selectedLineNotes);
        onTableDataChange(true);
        handleEditLineNotesShowModalClose();
      }
    } 

    //#region Send Invoice section
      function handleSendInvHeaderModalShow(invoiceRecord)
      {
          setSelectedSendInvoice(invoiceRecord);
          setSendInvHeaderModalShow(true);
      }
      
      const handleSendInvHeaderModalClose = () => setSendInvHeaderModalShow(false);

      function sendInvoiceEmail(invoice) {
        let tableValid = true;
        invoiceData.forEach(header => 
          {
            if(header.invoiceLines.length===0)
            {
              tableValid = false
            }
            else if (header.invoice_date === null) 
            {
              tableValid = false;
            }
            header.invoiceLines.forEach(line => {
              if(line.invoice_line_description==='-'){
                tableValid = false
              }
              if(line.invoice_line_total_exc===0){
                tableValid = false
              }
            });
          
        })

        if (tableValid) 
        {
          saveInvoiceHeader(invoiceData);
          let user = getTokenUser()
          let customer = customerOptions.filter(x => x.id === proposal.CustId)[0].value
          let invLines = "<br><p></p><table style='border: 1px solid black'><tr><th align='left' style='border: 1px solid black'>Invoice Line Description </th><th style='border: 1px solid black'>Unit Value</th><th style='border: 1px solid black'>Quantity</th><th style='border: 1px solid black'>Total Excl</th><th style='border: 1px solid black'>Total Incl</th></tr>"
          let customAttachments = ""
          invoice.invoiceLines.forEach(invLine => {
              invLines = invLines 
              + "<tr><td align='left' style='border: 1px solid black'>"
              + invLine.invoice_line_description
              + "</td><td style='border: 1px solid black'>"
              + invLine.invoice_line_unit_value
              + "</td><td style='border: 1px solid black'>" 
              + invLine.invoice_line_quantity
              + "</td><td style='border: 1px solid black'>"
              + invLine.invoice_line_total_exc
              + "</td><td style='border: 1px solid black'>"
              + invLine.invoice_line_total_inc
              + "</td></tr>"

              customAttachments = customAttachments+"<br>"+invLine.invoice_line_file
          })

          let message = 
          {
              toEmails: [ACCOUNT_EMAIL, getTokenEmail()],
              subject: "Invoice for " + customer + " - Invoice Date: "+invoice.invoice_date,
              body: "<b>Customer</b>: " + customer + ".<br><strong>Proposal</strong>: "+proposal.PropName +"<br><b>Invoice Description: </b>"+invoice.invoice_description +" <br><b>Invoice Date: </b>"+ invoice.invoice_date+"<br>" +                
                  invLines + "<tr><th style='border: 1px solid black'>  </th></tr>"+
                  "<tr><th align='left' style='border: 1px solid black'>Total excl:</th><th style='border: 1px solid black'>"+ invoice.invoice_total_exc +"</th></tr>" +
                  "<tr><th align='left' style='border: 1px solid black'>Total incl:</th><th style='border: 1px solid black'>"+ invoice.invoice_total_inc +"</th></tr></table>"  +
                  "<br>" +
                  "Notes: " + invoice.invoice_notes +
                  "<br>"+
                  "Attachments: " + customAttachments         
          }
  
          AxiosHelper.makeAxiosRequest("Create", "Email", "Send", null, message)
          .then((response) => {
              console.log(response)
          })
          .catch(error => {
              console.log(error)
          })
          handleSendInvHeaderModalClose()
          notifySuccessful("Changes saved & Invoice Request Sent!")
          setTimeout(() => 
          {
            window.location.reload();
          }, 2000);
        }
        else
        {
          notifyFailed("Please complete all Invoice details! Header cannot be saved without Line.")
        }
      }
    //#endregion

    //#endregion
    
  return (
    <div>

        {/* Confirm Invoice Delete Modal */}

        <Modal centered show={deleteInvHeaderModalShow} onHide={handleDeleteInvHeaderModalClose}>

          <Modal.Header closeButton>
            <Modal.Title>Delete Invoice</Modal.Title>
          </Modal.Header>
          
          <Modal.Body>
            <div style={{display: "flex", flexDirection: "column"}}>
                <div>
                    <p className="p-main">
                        Are you sure you want to delete the following invoice?
                        <br />
                        This change can not be reversed.
                      </p>
                </div>
                <div>
                    <p className="p-main">{selectedDeleteInvoice.invoice_description}</p>
                </div>
            </div>
          </Modal.Body>
          
          <Modal.Footer>
            <Button variant="primary" onClick={handleDeleteInvHeaderModalClose}>
              Cancel
            </Button>
            <Button variant="danger" onClick={() => onInvoiceDelete(selectedDeleteInvoice)}>
              Delete Invoice
            </Button>
          </Modal.Footer>

        </Modal>

        {/* Confirm Invoice Line Delete Modal */}

        <Modal centered show={deleteInvoiceLineModalShow} onHide={handleInvoiceLineDeleteModalClose}>

          <Modal.Header closeButton>
            <Modal.Title>Delete Invoice Line</Modal.Title>
          </Modal.Header>
          
          <Modal.Body>
            <div style={{display: "flex", flexDirection: "column"}}>
                <div>
                  <p className="p-main">
                    Are you sure you want to delete the following invoice line?
                    <br />
                    This change can not be reversed.
                  </p>
                </div>
                <div>
                    <p className="p-main">{selectedInvoiceLineDelete.invoice_line_description}</p>
                </div>
            </div>
          </Modal.Body>
          
          <Modal.Footer>
            <Button variant="primary" onClick={handleInvoiceLineDeleteModalClose}>
              Cancel
            </Button>
            <Button variant="danger" onClick={() => onInvoiceLineDelete(selectedInvoiceLineDelete)}>
              Delete Invoice Line
            </Button>
          </Modal.Footer>

        </Modal>

        {/* Confirm Cancel Modal */}

        <Modal centered show={cancelModalShow} onHide={handleCancelModalClose}>

          <Modal.Header closeButton>
            <Modal.Title>Clear Changes</Modal.Title>
          </Modal.Header>
          
          <Modal.Body>
            <div style={{display: "flex", flexDirection: "column"}}>
                <div>
                    <p className="p-main">
                      Are you sure you want to clear any changes made?
                      <br />
                      This does not include items that have been deleted.
                    </p>
                </div>
            </div>
          </Modal.Body>
          
          <Modal.Footer>
            <Button variant="primary" onClick={handleCancelModalClose}>
              Cancel
            </Button>
            <Button variant="danger" onClick={onCancelChanges}>
              Clear Changes
            </Button>
          </Modal.Footer>

        </Modal>

        {/* Cancel Proposal Modal */}

        <Modal centered show={cancelPropModalShow} onHide={handleCancelPropModalClose}>

          <Modal.Header closeButton>
            <Modal.Title>Clear Changes</Modal.Title>
          </Modal.Header>
          
          <Modal.Body>
            <div style={{display: "flex", flexDirection: "column"}}>
                <div>
                    <p className="p-main">
                      Are you sure you want to clear any changes made to the proposal?
                      <br />
                      This change can not be reversed.
                    </p>
                </div>
            </div>
          </Modal.Body>
          
          <Modal.Footer>
            <Button variant="primary" onClick={handleCancelPropModalClose}>
              Cancel
            </Button>
            <Button variant="danger" onClick={onCancelProposalChanges}>
              Clear Changes
            </Button>
          </Modal.Footer>

        </Modal>

        {/* Confirm edit or notes Modal*/}
        <Modal centered show={editNotesShow} onHide={handleEditNotesShowModalClose}>

        <Modal.Header closeButton>
        <Modal.Title>Edit Notes</Modal.Title>
        </Modal.Header>

        <Modal.Body>
        <div style={{justifyContent:"space-around"}}>
                  <h6 style={{textAlign: "center"}}>
                    Notes: 
                  </h6>
                  <FormR.Control
                    id="EditInvoiceNotes"
                    type="text"
                    as="textarea"
                    rows={4}
                    defaultValue={selectedNotes.invoice_notes}
                    style={{margin:"auto", maxWidth:"90%"}}
                    onBlur={(e) => {
                      if(!(e.target.value === "-")){
                        setNewSelectedNotes(e.target.value);
                      }
                    }
                  }
                  />
                </div>
        </Modal.Body>

        <Modal.Footer>
        <Button variant="primary" onClick={handleEditNotesShowModalClose}>
            Cancel
        </Button>
        <Button variant="danger" onClick={onEditNotesModalSave}>
            Ok
        </Button>
        </Modal.Footer>

        </Modal>

        {/* Confirm edit or Line notes Modal*/}
        <Modal centered show={editLineNotesShow} onHide={handleEditLineNotesShowModalClose}>

        <Modal.Header closeButton>
        <Modal.Title>Edit Line Notes</Modal.Title>
        </Modal.Header>

        <Modal.Body>
        <div style={{justifyContent:"space-around"}}>
                  <h6 style={{textAlign: "center"}}>
                    Line Notes: 
                  </h6>
                  <FormR.Control
                    id="EditInvoiceLineNotes"
                    type="text"
                    as="textarea"
                    rows={4}
                    defaultValue={selectedLineNotes.invoice_line_notes}
                    style={{margin:"auto", maxWidth:"90%"}}
                    onBlur={(e) => {
                      if(!(e.target.value === "-")){
                        setNewSelectedLineNotes(e.target.value);
                      }
                    }
                  }
                  />
                </div>
        </Modal.Body>

        <Modal.Footer>
        <Button variant="primary" onClick={handleEditLineNotesShowModalClose}>
            Cancel
        </Button>
        <Button variant="danger" onClick={onEditLineNotesModalSave}>
            Ok
        </Button>
        </Modal.Footer>

        </Modal>

        {/* Confirm edit or document link Modal*/}
        <Modal centered show={editDocumentLinkShow} onHide={handleEditDocumentLinkModalClose}>

        <Modal.Header closeButton>
        <Modal.Title>Edit Document Link</Modal.Title>
        </Modal.Header>

        <Modal.Body>
        <div style={{display:"flex", justifyContent:"space-around"}}>
                  <h6 style={{marginTop: "auto"}}>
                    Document Link: 
                  </h6>
                  <FormR.Control
                    id="EditProposalDocumentLink"
                    type="text"
                    defaultValue={selectedDocumentLink.invoice_line_file}
                    style={{maxWidth: "fit-content"}}
                    onBlur={(e) => {
                      if(!(e.target.value === "-")){
                        setNewSelectedDocumentLink(e.target.value);
                      }
                    }
                  }
                  />
                </div>
        </Modal.Body>

        <Modal.Footer>
        <Button variant="primary" onClick={handleEditDocumentLinkModalClose}>
            Cancel
        </Button>
        <Button variant="danger" onClick={onEditDocumentLinkModalSave}>
            Ok
        </Button>
        </Modal.Footer>

        </Modal>
        {/* Send Invoice Modal */}

        <Modal centered show={sendInvHeaderModalShow} onHide={handleSendInvHeaderModalClose}>

          <Modal.Header closeButton>
              <Modal.Title>Send Invoice</Modal.Title>
          </Modal.Header>

          <Modal.Body>
              <div style={{display: "flex", flexDirection: "column"}}>
                  <div>
                      <p className="p-main">
                          Are you sure you want to send the following invoice?
                      </p>
                  </div>
                  <div>
                      <p className="p-main">{selectedSendInvoice.invoice_description}</p>
                  </div>
              </div>
          </Modal.Body>

          <Modal.Footer>
              <Button variant="primary" onClick={handleSendInvHeaderModalClose}>
                  Cancel
              </Button>
              <Button variant="success" onClick={() => sendInvoiceEmail(selectedSendInvoice)}>
                  Send Invoice
              </Button>
          </Modal.Footer>

        </Modal>

        {shouldLogIn === true &&
            <div>
              <h1>Please log in to use this application</h1>
              <Button 
                onClick={NavigateToLogin}
                variant="primary" 
                className="login-button" >
                Login
              </Button>
            </div>
        }
        <ToastContainer />
        <NavBar/>
        
        {   proposalId !== 0 && proposalId != null &&
            <SubNavBar values={subNavValues}></SubNavBar>
        }  
        
        {   proposalId !== 0 &&
            <Container fluid id="proposal-update-container">
                <div className="proposal-collapse-toggle-container">
                    <Row className="proposal-collapse-toggle-wrapper gx-0">
                        <Col style={{display: "flex"}}>
                            <p className="proposal-collapse-toggle" >View Invoices</p>
                        </Col>
                    </Row>
                    <Collapse className="proposal-collapse-table gx-0" in={proposalTableOpen}>
                        <Row>
                            <Col className="proposal-update-collapse-body">
                    <Table
                      components={components}
                      columns={invHeadercolumns}
                      onChange={onChange}
                      pagination={{
                        position: ["bottomCenter"],
                        showSizeChanger: false,
                        defaultPageSize: 100,
                        hideOnSinglePage: true,
                        pageSizeOptions: [5 , 10, 20, 50, 100]
                      }}
                      dataSource={invoiceData}
                      footer={() => (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Button onClick={handleInvoiceHeaderAdd}>Add</Button>
                          <div style={{ display: "flex", gap: "20px" }}>
                            <Button
                              onClick={handleBackClick}
                              style={{ alignSelf: "right" }}
                            >
                              Back
                            </Button>
                            <Button
                              variant="danger"
                              onClick={handleCancelModalShow}
                              style={{ alignSelf: "right" }}
                            >
                              Clear Changes
                            </Button>
                            <Button
                              variant="success"
                              onClick={SaveTable}
                              style={{ alignSelf: "right" }}
                            >
                              Save Changes
                            </Button>
                          </div>
                        </div>
                      )}
                      expandable={{
                        rowExpandable: (record2) => true,
                        expandedRowRender: (record2) => {
                          return (
                            <Table
                              components={components}
                              columns={invLinecolumns}
                              pagination={{
                                position: ["bottomCenter"],
                                showSizeChanger: false,
                                defaultPageSize: 100,
                                hideOnSinglePage: true,
                                pageSizeOptions: [5 , 10, 20, 50, 100]
                              }}
                              dataSource={record2.invoiceLines}
                              footer={() => (
                                <div>
                                  <Button
                                    onClick={() =>
                                      handleInvoiceLineAdd(record2)
                                    }
                                  >
                                    Add
                                  </Button>
                                </div>
                              )}
                            ></Table>
                          );
                        },
                      }}
                    ></Table>
                  </Col>
                </Row>
              </Collapse>
            </div>
          </Container>
        }

      {proposalId === 0 && (
        <Container fluid style={{ marginTop: "40px" }}>
          <Row className="justify-content-md-center">
            <Col xs={1}></Col>
            <Col xs={6}>
              <div id="proposal-create-form">
                <p className="proposal-create-body-details-heading">
                  Proposal Information
                </p>
                <FormR noValidate validated={isCreateValidated} onSubmit={onProposalCreateFormSubmitHandler}>
                  <FormR.Group className="mb-3" controlId="formBasicUsername">

                    <div className="row justify-content-center proposal-input-row">
                      <div className="col-12">
                        <h2 className="proposal-create-input-title">Name</h2>
                        <FormR.Control
                          name="createPropName"
                          id="CreatePropName"
                          type="text"
                          pattern="[a-zA-Z 0-9()\-]+"
                          required
                        />
                        <FormR.Control.Feedback type="invalid">Please enter a valid name</FormR.Control.Feedback>
                      </div>
                    </div>

                    <div className="row justify-content-center proposal-input-row">
                      <div className="col-12">
                        <h2 className="proposal-create-input-title">
                          Customer
                        </h2>
                        <FormR.Select
                          aria-label="Default select example"
                          name="createPropCustomer"
                          id="CreatePropCustomer"
                          required
                        >
                          {customerOptions.map((customerOption) => (
                            <option value={customerOption.id}>
                              {customerOption.value}
                            </option>
                          ))}
                        </FormR.Select>
                      </div>
                    </div>

                    <div className="row justify-content-center proposal-input-row">
                      <div className="col-6">
                        <h2 className="proposal-create-input-title">
                          Date From
                        </h2>
                        <FormR.Control
                          id="CreatePropDateFrom"
                          type="date"
                          required
                        />
                        <FormR.Control.Feedback type="invalid">Please enter a valid date</FormR.Control.Feedback>
                      </div>
                      <div className="col-6">
                        <h2 className="proposal-create-input-title">
                          Date To
                        </h2>
                        <FormR.Control
                          id="CreatePropDateTo"
                          type="date"
                          required
                        />
                        <FormR.Control.Feedback type="invalid">Please enter a valid date</FormR.Control.Feedback>
                      </div>
                    </div>

                    <div className="row justify-content-center proposal-input-row">
                      <div className="col-6">
                        <h2 className="proposal-create-input-title">
                          Unit Quantity
                        </h2>
                        <FormR.Control
                          id="CreatePropUnitQty"
                          type="number"
                          required
                          onChange={(e) => {onCreateProposalChange(e)}}
                          pattern="^[+-]?([0-9]*[.])?[0-9]+$"
                        />
                        <FormR.Control.Feedback type="invalid">Please enter a valid quantity</FormR.Control.Feedback>
                      </div>
                      <div className="col-6">
                        <h2 className="proposal-create-input-title">
                          Unit Value
                        </h2>
                        <FormR.Control
                          id="CreatePropUnitValue"
                          type="text"
                          onChange={(e) => {onCreateProposalChange(e)}}
                          pattern="^[+-]?([0-9,]*[.]?)?[0-9]+$"
                          required
                        />
                        <FormR.Control.Feedback type="invalid">Please enter a valid value</FormR.Control.Feedback>
                      </div>
                    </div>

                    <div className="row justify-content-center proposal-input-row">
                      <div className="col-6">
                        <h2 className="proposal-create-input-title">
                          Frequency Type
                        </h2>
                        <FormR.Select
                          aria-label="Default select example"
                          id="CreatePropFreqType"
                          required
                        >
                          {frequencyTypeOptions.map((frequencyTypeOption) => (
                            <option value={frequencyTypeOption.id}>
                              {frequencyTypeOption.value}
                            </option>
                          ))}
                        </FormR.Select>
                      </div>
                      <div className="col-6">
                        <h2 className="proposal-create-input-title">
                          Frequency Quantity
                        </h2>
                        <FormR.Control
                          id="CreatePropFreqQty"
                          type="number"
                          onChange={(e) => {onCreateProposalChange(e)}}
                          pattern="^[+-]?([0-9]*[.])?[0-9]+$"
                          required
                        />
                        <FormR.Control.Feedback type="invalid">Please enter a valid quantity</FormR.Control.Feedback>
                      </div>
                    </div>

                    <div className="row justify-content-center proposal-input-row">
                      <div className="col-6">
                        <h2 className="proposal-create-input-title">
                          Sub Total Excl. VAT
                        </h2>
                        <FormR.Control
                          id="CreatePropSubTotalExc"
                          type="text"
                          disabled="disabled"
                        />
                      </div>
                      <div className="col-6">
                        <h2 className="proposal-create-input-title">
                          Sub Total Incl. VAT
                        </h2>
                        <FormR.Control
                          id="CreatePropSubTotalInc"
                          type="text"
                          disabled="disabled"
                        />
                      </div>
                    </div>

                    <div className="row justify-content-center proposal-input-row">
                      <div className="col-6">
                        <h2 className="proposal-create-input-title">
                          Total Excl. VAT
                        </h2>
                        <FormR.Control
                          id="CreatePropTotalExc"
                          type="text"
                          disabled="disabled"
                        />
                      </div>
                      <div className="col-6">
                        <h2 className="proposal-create-input-title">
                          Total Incl. VAT
                        </h2>
                        <FormR.Control
                          id="CreatePropTotalInc"
                          type="text"
                          disabled="disabled"
                        />
                      </div>
                    </div>

                    <div className="row justify-content-center proposal-input-row">
                      <div className="col-6">
                        <h2 className="proposal-create-input-title">
                            Link To File On SharePoint
                          </h2>
                          <FormR.Control
                            id="CreatePropFileLink"
                            type="text"
                            pattern="^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$"
                          />
                          <FormR.Control.Feedback type="invalid">Please enter a valid link</FormR.Control.Feedback>
                      </div>
                      <div className="col-6">
                      <h2 className="proposal-create-input-title">Notes</h2>
                        <FormR.Control
                          id="CreatePropNotes"
                          type="text"
                        />
                      </div>
                    </div>

                    <div className="row justify-content-center proposal-input-row">
                      <div className="col-12">
                        
                      </div>
                    </div>
                    
                    <div className="row justify-content-center proposal-button-row">
                      <div className="col-6">
                        <Button
                          variant="danger"
                          onClick={handleCancelModalShow}
                          style={{ alignSelf: "right" }}
                        >
                          Cancel
                        </Button>
                      </div>
                      <div className="col-6">
                        <Button
                          variant="success"
                          class="proposal-input-button"
                          type="submit"
                        >
                          Create Proposal
                        </Button>
                        
                      </div>
                    </div>
                  </FormR.Group>
                </FormR>
              </div>
            </Col>
            <Col xs={1}></Col>
          </Row>
        </Container>
      )}
    </div>
  );
}
  
export default Proposal;
  